import React, { useEffect, useState } from "react";
import { DefaultDropdown } from "../../../../_helpers/components/Forms/Dropdown";
import { InputForm } from "../../../../_helpers/components/Forms/InputLabel";
import {
    createContract,
    editContract,
    deleteContract,
} from "../../../../_api/Contract";
import { getWorkShifts } from "../../../../_api/WorkShift";
import { Button } from "../../../../_helpers/components/Button";
import { toast } from "react-hot-toast";

export const ContractForm = (props) => {
    const {
        closeModal,
        profile,
        refreshProfil,
        contract,
        onChange,
        removeContract,
    } = props;

    const [startDate, setStartDate] = useState(contract?.start_date ?? "");
    const [endDate, setEndDate] = useState(contract?.end_date ?? "");
    const [contractType, setContractType] = useState(contract?.type ?? "CDI");
    const [contractName, setContractName] = useState(contract?.name ?? "");

    const [cycles, setCycles] = useState(contract?.user_work_shifts ?? []);
    const [cycleOptions, setCycleOptions] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleSave = () => {
        if (onChange) {
            let contract = {
                id: generateKey(),
                start_date: startDate,
                end_date: endDate,
                type: contractType,
                name: contractName,
                user_work_shifts: cycles,
            };
            onChange({ contract });
        }
        closeModal();
    };

    const refresh = () => {
        setStartDate();
        setEndDate();
        setContractName("");
        setContractType("CDI");
        closeModal();
        refreshProfil();
    };

    const generateKey = (length = 32) => {
        const chars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let key = "";
        for (let i = 0; i < length; i++) {
            key += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return key;
    };

    useEffect(() => {
        getWorkShifts().then((resp) => {
            setCycleOptions(
                resp.data.map((res) => ({
                    value: res.id,
                    label: res.name,
                    rate: res.rate,
                    unit: res.unit,
                    number_of: res.number_of,
                }))
            );
        });
    }, []);

    const updateCycle = (id, field, value) => {
        setCycles((prevCycles) =>
            prevCycles.map((c) =>
                c.id === id
                    ? {
                        ...c,
                        [field]: value,
                    }
                    : c
            )
        );
    };

    const addCycle = () => {
        const defaultCycle = cycleOptions[0];
        setCycles([
            ...cycles,
            {
                id: generateKey(),
                rate: 100,
                start_date: "",
                end_date: "",
                start_week_or_day: "",
                work_shift_id: defaultCycle ? defaultCycle.value : "",
            },
        ]);
    };

    const removeCycle = (id) => {
        setCycles(cycles.filter((c) => c.id !== id));
    };

    const verif = () => {
        if (!startDate) {
            toast.error("La date de début de contrat est obligatoire");
            return false;
        }
        const periodes = [];

        for (const c of cycles) {
            if (!c.start_date) {
                toast.error("La date de début de cycle est obligatoire");
                return false;
            }
            periodes.push(...[{ start: c.start_date, end: c.end_date == "" ? "2099-12-31" : c.end_date }]);
        }

        periodes.sort((a, b) => a.start < b.start ? -1 : 1);
        for (let i = 1; i < periodes.length; i++) {
            if (new Date(periodes[i - 1].end) >= new Date(periodes[i].start)) {
                toast.error("Il y a des chevauchements de dates dans les périodes des cycles");
                return false;
            }
        }

        return true;
    }

    return (
        <>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full md:w-1/2 px-2">
                    <InputForm
                        name="Début de contrat"
                        type="date"
                        required={true}
                        value={startDate}
                        placeholder="siret"
                        set={setStartDate}
                    />
                </div>
                <div className="w-full md:w-1/2 px-2">
                    <InputForm
                        name="Fin de contrat"
                        type="date"
                        value={endDate}
                        set={setEndDate}
                    />
                </div>
            </div>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full md:w-1/2 px-2">
                    <InputForm
                        name="Intitulé du poste"
                        type="text"
                        value={contractName}
                        placeholder="Ingénieur"
                        set={setContractName}
                    />
                </div>
                <div className="w-full md:w-1/2 px-2">
                    <DefaultDropdown
                        name="Type de contrat"
                        required={true}
                        options={["CDI", "CDD"]}
                        value={contractType}
                        onChange={(e) => setContractType(e.target.value)}
                    />
                </div>
            </div>
            <hr />
            {cycleOptions.length > 0 && (
                <>
                    {" "}
                    <div className="flex justify-between">
                        <div>
                            <h4 className="text-center block uppercase tracking-wide text-app-primary text-sm font-bold mb-2">
                                Gestion des cycles
                            </h4>
                        </div>
                        <div>
                            <Button type="empty" name="+" action={addCycle} />
                        </div>
                    </div>
                    {cycles.map((cycle, index) => {
                        const selectedCycle = cycleOptions.find(
                            (opt) => opt.value == cycle.work_shift_id
                        );
                        return (
                            <div key={cycle.id} className="relative mt-3">
                                <div className="flex flex-wrap -mx-2">
                                    <div className="w-full md:w-1/2 px-2 mb-3">
                                        <DefaultDropdown
                                            options={cycleOptions}
                                            name="Cycle"
                                            required={true}
                                            value={cycle.work_shift_id}
                                            onChange={(e) => updateCycle(cycle.id, "work_shift_id", e.target.value)}
                                        />
                                    </div>
                                    <div className="w-full px-2 md:w-1/2">
                                        <InputForm
                                            name="Taux (%)"
                                            type="number"
                                            required={true}
                                            value={cycle.rate}
                                            placeholder="100%"
                                            set={(val) =>
                                                updateCycle(
                                                    cycle.id,
                                                    "rate",
                                                    val
                                                )
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-2">
                                    <div className="w-full md:w-1/2 px-2 mb-3">
                                        <InputForm
                                            name="Début du cycle"
                                            type="date"
                                            required={true}
                                            value={cycle.start_date}
                                            set={(val) =>
                                                updateCycle(
                                                    cycle.id,
                                                    "start_date",
                                                    val
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="w-full md:w-1/2 px-2 mb-3">
                                        <InputForm
                                            name="Fin du cycle"
                                            type="date"
                                            value={cycle.end_date}
                                            set={(val) =>
                                                updateCycle(
                                                    cycle.id,
                                                    "end_date",
                                                    val
                                                )
                                            }
                                        />
                                    </div>
                                </div>

                                {selectedCycle &&
                                    ["d", "w"].includes(selectedCycle.unit) &&
                                    selectedCycle.number_of > 1 && (
                                        <DefaultDropdown
                                            options={Array.from(
                                                {
                                                    length: selectedCycle.number_of,
                                                },
                                                (_, i) => ({
                                                    value: i + 1,
                                                    label: `${selectedCycle.unit ===
                                                        "w"
                                                        ? "Semaine"
                                                        : "Jour"
                                                        } ${i + 1}`,
                                                })
                                            )}
                                            name={"Commencer ce cycle par : "}
                                            value={cycle.start_week_or_day}
                                            onChange={(e) => updateCycle(cycle.id, "start_week_or_day", parseInt(e.target.value))}
                                        />
                                    )}

                                <button
                                    type="button"
                                    onClick={() => removeCycle(cycle.id)}
                                    className="absolute top-0 right-0 text-red-500 px-2"
                                >
                                    ✕
                                </button>
                            </div>
                        );
                    })}
                </>
            )}

            <div className="flex justify-end ml-2 mt-2">
                {contract && (
                    <div className="m-1">
                        <Button
                            id="add"
                            type={"red"}
                            loading={isDeleting}
                            action={() => {
                                if (!profile) {
                                    removeContract(contract);
                                    closeModal();
                                    return;
                                }
                                setIsDeleting(true);
                                deleteContract(contract.id)
                                    .then((resp) => {
                                        refreshProfil();
                                        closeModal();
                                    })
                                    .finally(() => {
                                        setIsDeleting(false);
                                    });
                            }}
                            name={
                                <svg
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M5.12817 8.15391C5.12817 10.4103 5.12817 13.5898 5.12817 15.1283C5.23074 16.4616 5.3333 18.2052 5.43587 19.436C5.53843 20.8719 6.7692 22.0001 8.2051 22.0001H15.7948C17.2307 22.0001 18.4615 20.8719 18.5641 19.436C18.6666 18.2052 18.7692 16.4616 18.8718 15.1283C18.9743 13.5898 18.8718 10.4103 18.8718 8.15391H5.12817Z"
                                        fill="#FFFFFF"
                                    />
                                    <path
                                        d="M19.1795 5.07698H16.6154L15.7949 3.53852C15.2821 2.61545 14.359 2.00006 13.3333 2.00006H10.8718C9.84615 2.00006 8.82051 2.61545 8.41026 3.53852L7.38462 5.07698H4.82051C4.41026 5.07698 4 5.48724 4 5.8975C4 6.30775 4.41026 6.71801 4.82051 6.71801H19.1795C19.5897 6.71801 20 6.41032 20 5.8975C20 5.38468 19.5897 5.07698 19.1795 5.07698ZM9.12821 5.07698L9.64103 4.25647C9.84615 3.84621 10.2564 3.53852 10.7692 3.53852H13.2308C13.7436 3.53852 14.1538 3.74365 14.359 4.25647L14.8718 5.07698H9.12821Z"
                                        fill="#FFFFFF"
                                    />
                                </svg>
                            }
                        />
                    </div>
                )}
                <div className="m-1">
                    <Button
                        id="add"
                        type={"empty"}
                        action={closeModal}
                        name="Annuler"
                    />
                </div>
                <div className="m-1">
                    <Button
                        id="add"
                        loading={isSaving}
                        action={() => {

                            if (!verif()) return;

                            const payload = {
                                start_date: startDate,
                                end_date: endDate,
                                contract_name: contractName,
                                contract_type: contractType,
                                cycles: cycles,
                            };
                            
                            if (!profile) {
                                handleSave();
                                return;
                            }

                            setIsSaving(true);
                            const savePromise = contract
                                ? editContract(payload, contract.id)
                                : createContract(payload, profile.id);

                            savePromise
                                .then(() => {
                                    refresh();
                                })
                                .finally(() => {
                                    setIsSaving(false);
                                });
                        }}
                        name={contract ? "Editer" : "Créer le contrat"}
                    />
                </div>
            </div>
        </>
    );
};
